import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getDiffDirectionSymbol, getDiffColor } from '../../BuildingAnalytics/helpers'

const noDataServices = Array(10).fill(0)

const Services = ({ services }) => {
  const { t } = useTranslation(['building-analytics'])
  const renderServices = () =>
    services.map((service, i) => {
      return (
        <div key={i} className="scroll-item">
          <span className="scroll-item__title">{service.name}</span>
          <div className="scroll-item__wrapper">
            <h3 className="scroll-item__wrapper__number">{service.total.value}</h3>
            {service.total && service.total.percentageDiff !== '-' && (
              <span className={`percent-text  ${getDiffColor(service.total)}`}>
                {getDiffDirectionSymbol(service.total.percentageDiff)}{' '}
                {service.total.percentageDiff}
              </span>
            )}
          </div>
        </div>
      )
    })

  return (
    <div className="operation-data__services-block__wrapper">
      <h3 className="operation-data__services-block__wrapper__title">
        {t('building-analytics:servicesBlock.title')}
      </h3>
      <h4 className="operation-data__services-block__wrapper__subtitle">
        {t('building-analytics:servicesBlock.appointmentsBookedTotal')}
      </h4>
      {services && services.length ? (
        <div className="operation-data__services-block__wrapper__scrollable-line">
          {renderServices()}
        </div>
      ) : (
        <div className="operation-data__services-block__wrapper__scrollable-line">
          {noDataServices.map((service, i) => (
            <div key={i} className="scroll-item">
              <span className="scroll-item__title">
                {t('building-analytics:servicesBlock.categoryNamePlaceholder')}
              </span>
              <div className="scroll-item__wrapper">
                <h3 className="scroll-item__wrapper__number">0</h3>
                <span className="percent-text">00.00%</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

Services.propTypes = {
  services: PropTypes.array,
}
export default Services
